import React from 'react';
import * as S from './style';
import { InputOnlyNumber, Btn, Label } from 'components';
import { zeroPad } from 'commons/ZimssaHelper';
import { PLACEHOLDER_AUTH_CODE, BUTTON_VERIFY_REQ, BUTTON_VERIFY_COMPLETE } from 'commons/ZimssaString';

export function getAuthTimer(time: number): string {
    let min = Math.floor(time / 60);
    let sec = time - min * 60;

    return (min === 0 && sec === 0)? '0' : `${zeroPad(min)}:${zeroPad(sec)}`;
}

export interface Props {
    timer: number;
    value: string;
    isVerify: boolean;
    onClickVerify: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onChangeHandler: (type: any, value: string) => void;
}

function PhoneAuthCode({ timer, value, isVerify = false, onClickVerify, onChangeHandler }: Props): React.ReactElement {
    const authTimeout = !isVerify && timer === 0;
    const verifiedOrTimeout = isVerify || authTimeout;

    return (
        <S.PhoneAuthCodeContainer>
            <S.InputNumberWrapper>
                <InputOnlyNumber value={value} inputName={'authCode'} placeholder={PLACEHOLDER_AUTH_CODE} maxLength={4} onChangeHandler={onChangeHandler} />
            </S.InputNumberWrapper>
            <S.LabelBtnWrapper>
                <S.LabelTimerWrapper>
                    <Label contents={getAuthTimer(timer)} color={'text_dark_main'} fontStyle={'subtitle2_bold'} />
                </S.LabelTimerWrapper>
                <S.BtnAuthVerfiyWrapper>
                    <Btn fontStyle={'body2'} backGroundColor={verifiedOrTimeout? 'gray_opacity_200' : 'blue_900'} disabled={authTimeout} color={'gray_opacity_50'} children={isVerify ? BUTTON_VERIFY_COMPLETE : BUTTON_VERIFY_REQ} onClick={onClickVerify} />
                </S.BtnAuthVerfiyWrapper>
            </S.LabelBtnWrapper>
        </S.PhoneAuthCodeContainer>
    );
}

export default PhoneAuthCode;
